// part.3我的目标
<template>
    <div class='pageTargetSplit' v-if="Array.isArray(myGoalDisassemble)&&myGoalDisassemble.length">
        <div  v-for="(value,index) in myGoalDisassemble" :key="index"  class="content contentTargetSplit">
            <MiddleTitle  v-if="index==0" title='目标拆分'></MiddleTitle>
            <SmallTitle :title="value.name"></SmallTitle>
            <div class="target">
                <p class="targetTitle">学业目标</p>
                <div class="targetBox">
                    <p>
                        <span>总分：{{getData(value).xueye[0].value}}分</span>
                        <span>年级排名：{{getData(value).xueye[1].value}}名</span>
                    </p>
                </div>
            </div>
            <div class="target">
                <p class="targetTitle">科目目标</p>
                <div class="targetBox">
                    <ul>
                        <li v-for="(val,idx) in getData(value).kemu" :key="idx">{{val.name}}：{{val.score}}分/{{val.rank}}名</li>
                        <li></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import BigTitle from './bigTitle'
import MiddleTitle from './middleTitle'
import SmallTitle from './smallTitle'
import PlanTable from "./planTable/planTable";
export default {
    name: "pageTargetSplit",
    props: ['myGoalDisassemble'],
    components: {
        BigTitle,MiddleTitle,SmallTitle,PlanTable
    },
    data() {
        return {

        }
    },
    methods: {
        getData(value) {
            let data = {};
            (JSON.parse(value.target).forEach((item)=> {
                if (value.name == item.name) {
                    data = item;
                }
            }))
            console.log(data)
            return data;
        }
    },
}
</script>
<style scoped lang="less">
</style>